import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: ['en', 'te', 'hi', 'ta', 'kn', 'gu', 'mr', 'bn', 'ml', 'or'],
        resources: {
            
        },
        // useSuspense: true,
        lng: "en",
        fallbackLng: 'en',
        debug: false,
        react: {
            useSuspense: true,
        },

        

        interpolation: {
            escapeValue: true // React already does escaping
        }
    });

export default i18n;
